export const coinIcons = {
  USDT: 'https://assets.coingecko.com/coins/images/325/standard/Tether.png?1696501661',
  USDC: 'https://assets.coingecko.com/coins/images/6319/standard/usdc.png?1696506694',
  ARB: 'https://assets.coingecko.com/coins/images/16547/standard/arb.jpg?1721358242',
  BONK: 'https://assets.coingecko.com/coins/images/28600/standard/bonk.jpg?1696527587',
  DAI: 'https://assets.coingecko.com/coins/images/9956/standard/Badge_Dai.png?1696509996',
  LINK: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009',
  PENDLE:
    'https://assets.coingecko.com/coins/images/15069/standard/Pendle_Logo_Normal-03.png?1696514728',
  WBTC: 'https://assets.coingecko.com/coins/images/7598/standard/wrapped_bitcoin_wbtc.png?1696507857',
  AERO: 'https://assets.coingecko.com/coins/images/31745/standard/token.png?1696530564',
  APE: 'https://assets.coingecko.com/coins/images/24383/standard/apecoin.jpg?1696523566',
  BLUR: 'https://assets.coingecko.com/coins/images/28453/standard/blur.png?1696527448',
  BOND: 'https://assets.coingecko.com/coins/images/12811/standard/barnbridge.jpg?1696512604',
  BRETT: 'https://assets.coingecko.com/coins/images/35529/standard/1000050750.png?1709031995',
  DEGEN:
    'https://assets.coingecko.com/coins/images/34515/standard/android-chrome-512x512.png?1706198225',
  FRIEND: 'https://assets.coingecko.com/coins/images/37475/standard/friend.jpeg?1714464901',
  PEPE: 'https://assets.coingecko.com/coins/images/29850/standard/pepe-token.jpeg?1696528776',
  SAND: 'https://assets.coingecko.com/coins/images/12129/standard/sandbox_logo.jpg?1696511971',
  SHIB: 'https://assets.coingecko.com/coins/images/11939/standard/shiba.png?1696511800',
  WETH: 'https://assets.coingecko.com/coins/images/2518/standard/weth.png?1696503332',
  WMATIC: 'https://assets.coingecko.com/coins/images/32922/standard/wmatic.png?1699825896',
  WPOL: 'https://assets.coingecko.com/coins/images/14073/standard/matic.png?1696513797',
};
